const TextAreaComponent = ({ title, name, value, onBlur, onChange, rows }: any) => {
    return (
        <div className="flex flex-col gap-[4px]   focus:border-[#333] hover:border-[#999]">
            <label className="text-[#5C5C5C] text-xs font-normal" htmlFor="first_name">{title}</label>
            <textarea className="rounded-[7px] bg-[#F4F4F9] border border-[#5553] focus:border-[#999] hover:border-[#999] p-[10px]  text-secondaryText dark:text-grey text-sm font-normal" name={name} value={value} rows={rows} onBlur={onBlur} onChange={onChange} />
        </div>
    );
};

export default TextAreaComponent;